import { generate } from '../../../core/js/utils/componentUtils';
import { dDom } from '../../../core/js/utils/renderUtils';
import { bindOnPopStateEvent } from '../../../core/js/utils/browserUtils';
import { closeModal } from '../../../core/js/utils/modalUtils';
import { removeHash } from '../../../core/js/utils/routerUtils';

import template from 'modal/informational-markdown.j2';

function firstRender(store) {
    this.render(store, this, { markdownSlug: this.markdownSlug });
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        name: 'modal.informational',
        renderType: dDom,
        template: template,
        firstRender: firstRender,
        markdownSlug: window.location.hash.split('=')[1] ? window.location.hash.split('=')[1] : null,
        afterCloseAction: afterCloseAction
    };

    if (_.get(store.getState(), `core.localizations.containers.chromeLocalization.${config.markdownSlug
        }`)) {
        return generate(config, store, overrides);
    }

    return {};
}

function afterCloseAction(store) {
    // Remove hash and push state on close
    removeHash();
}

function attachEvents(store) {
    // Close modal on back-button
    bindOnPopStateEvent(this, function(e) {
        closeModal(this, e);
    });
}
